import { useSelector } from 'react-redux';

import { DesktopAfterUserChoosePage } from './Desktop';
import { MobileAfterUserChoosePage } from './Mobile';
import { PANEL } from '../../../../constants/Panel';
import { useBuyPredictionIfNeeded } from '../../../../hooks/useBuyPredictionIfNeeded';
import { useRouter } from '../../../../hooks/useRouter';
import { selectSelectedUserData } from '../../../../store/FriendSearchSlice/popoutSelectors';
import { selectIsDesktop } from '../../../../store/settingsSlice/settingsSelectors';

export const AfterUserChoosePage = () => {
  const isDesktop = useSelector(selectIsDesktop);

  const router = useRouter();
  const onGetResultHandler = useBuyPredictionIfNeeded(
    async () => {
      await router.forward({ panel: PANEL.RESULT });
    }
  );
  const user = useSelector(selectSelectedUserData);

  if (isDesktop) {
    return (
      <DesktopAfterUserChoosePage 
        onGetResultHandler={onGetResultHandler}
        friend={user}/>
    );
  }

  return (
    <MobileAfterUserChoosePage 
      onGetResultHandler={onGetResultHandler}
      friend={user}/>
  );
};
